module.exports = __webpack_public_path__ + "static/media/share.d5396823.svg";